import { State as DataQueryState } from '@progress/kendo-data-query';

export enum AsyncActionStatus {
    idle = 'idle',
    loading = 'loading',
    succeeded = 'succeeded',
    failed = 'failed',
}

export interface ApiCallState<TData = any> {
    info: TData;
    status: AsyncActionStatus;
    error: string;
}
export interface CammandResponseState {
    info: string;
    error: boolean;
    time?: number | undefined;
}

export const getApiCallInitialState = (info: any = {}) => ({ info, status: AsyncActionStatus.idle, error: '' });
export const getCammandResponseInitialState = () => ({ info: '', error: false, time: undefined });

export interface DataResult<TData = any> {
    total: number;
    data: Array<TData> | null;
}

export interface GridState<TData = any> {
    queryState: DataQueryState;
    queryResult: ApiCallState<DataResult<TData>>;
}

export const getInitialGridState = (take = 50): GridState => ({
    queryState: {
        take,
        skip: 0,
    },
    queryResult: getApiCallInitialState({ data: [], total: 0 }),
});
